export default __webpack_public_path__ + "static/media/bubble_nova_background_s2.d886dc82.jpg";